<hr class="mb-1 mt-0 text-black">
<div class="mb-4">
  <span class="h4">Internal Notes</span>
  <app-expand-collapse-button [targetSectionId]="'internalNotesExpandCollapse'"></app-expand-collapse-button>
  <app-spinner [show]="false" [center]="false"></app-spinner>
</div>
<app-expand-collapse-section [sectionId]="'internalNotesExpandCollapse'" [isOpen]="true">
  <fieldset class="pb-4">
    <textarea [(ngModel)]="claimDto!.internalNotes" (keyup)="updateInternalNotes()" class="form-control"
              rows="5"></textarea>
    <small class="d-block pb-3">Internal comments are not visible to the repair center.</small>
  </fieldset>
</app-expand-collapse-section>